import {Editor} from "@tiptap/core";
import ICONS from "../../assets/ICONS";
import {Transaction} from "prosemirror-state";
import {DceJsx} from "dce-jsx";
import {ToolbarItem} from "../ToolbarItem";

export default class AiGeneratorButton extends ToolbarItem {

    private editor:Editor;

    private options: HTMLElement;

    private optionsUrl: HTMLInputElement;
    private optionsTarget: HTMLSelectElement;
    private optionsBtnAccept: HTMLButtonElement;
    private optionsBtnRemove: HTMLButtonElement;

    constructor() {
        super();
    }

    mount(editor: Editor): void {
        this.editor = editor;
    }

    public click(e: any): void {

        this.editor.commands.setAiGenerator({
            prompt: ""
        });

    }

    public consumeTransaction(editor: Editor, transaction: Transaction): void{

    }

    public setLink(): void {

    }

    public isActive(editor:Editor): boolean {
        return this.editor.isActive('ai-block');
    }

    render(): JSX.Element {
        return (
            <button type="button" onClick={(e) => this.click(e)} className={"btn"}>
                <i ref={"current-icon"} dangerouslySetInnerHTML={{__html: ICONS.aiWand}}></i>
            </button>
        );
    }
}